let district = [
    { "x": -1, "y": -1, "type": "right", "opts": "start", "pickup": false },
    { "x": -3, "y": -2, "type": "righttoleft" },
    { "x": -3, "y": -3, "type": "left" },
    { "x": -3, "y": -4, "type": "left" },
    { "x": -3, "y": -5, "type": "left" },
    { "x": -4, "y": -7, "type": "lefttoright" },
    { "x": -5, "y": -7, "type": "voidright" },
    { "x": -6, "y": -7, "type": "right" },
    { "x": -7, "y": -7, "type": "righttop" },
    { "x": -8, "y": -8, "type": "top" },
    { "x": -9, "y": -9, "type": "topright" },
    { "x": -10, "y": -9, "type": "voidright" },
    { "x": -11, "y": -9, "type": "righttop" },
    { "x": -12, "y": -10, "type": "topleft" },
    { "x": -12, "y": -11, "type": "left" },
    { "x": -12, "y": -12, "type": "voidleft" },
    { "x": -12, "y": -13, "type": "left" },
    { "x": -12, "y": -14, "type": "left" },
    { "x": -12, "y": -15, "type": "left" },
    { "x": -12, "y": -16, "type": "voidleft" },
    { "x": -13, "y": -18, "type": "lefttoright" },
    { "x": -22, "y": -22, "type": "plateforme", "pickup": false },

    /* Fake path */
    { "x": -18, "y": -13, "type": "left", "pickup": false }, 
    { "x": -18, "y": -25, "type": "leftbottorightbot", "pickup": false },

    { "x": -18, "y": -23, "type": "left", "pickup": false },

    { "x": -18, "y": -8, "type": "left", "pickup": false },
    { "x": -18, "y": -9, "type": "left", "pickup": false },
    { "x": -18, "y": -10, "type": "left", "pickup": false },
    { "x": -18, "y": -11, "type": "left", "pickup": false },
    { "x": -18, "y": -12, "type": "left", "pickup": false },

    { "x": -16, "y": -25, "type": "left", "pickup": false },
    { "x": -15, "y": -25, "type": "left", "pickup": false },
    /* */

    {
        "x": -31,
        "y": -31,
        "type": "gate1",
        "move": false,
        "pickup": false
    },
    { "x": -24, "y": -19, "type": "righttoleft" },
    { "x": -24, "y": -20, "type": "left" },
    { "x": -24, "y": -21, "type": "left","pickup": false },
    { "x": -24, "y": -22, "type": "left", "pickup": false },
    { "x": -24, "y": -23, "type": "left", "pickup": false },
    { "x": -24, "y": -24, "type": "left", "pickup": false },
    { "x": -24, "y": -25, "type": "left", "pickup": false },
    { "x": -24, "y": -26, "type": "lefttop" },
    { "x": -25, "y": -27, "type": "topleft" },
    { "x": -25, "y": -28, "type": "left" },
    { "x": -25, "y": -29, "type": "left" },
    { "x": -26, "y": -31, "type": "lefttoright" },
    { "x": -27, "y": -31, "type": "right" },
    { "x": -28, "y": -31, "type": "voidright" },
    { "x": -29, "y": -31, "type": "righttop" },
    { "x": -30, "y": -32, "type": "topright", "pickup": false },
    { "x": -31, "y": -32, "type": "right", "opts": "end", "pickup": false }
];

export default district;